import { createContext } from "react";
import type { ModalsContextType } from "./useModals";

export const ModalsContext = createContext<ModalsContextType | undefined>(undefined);
